import { useState } from "react";
import { Crown, Users, Megaphone, BadgeCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { UsersPanel } from "@/components/super/UsersPanel";
import { SponsoredPanel } from "@/components/super/SponsoredPanel";
import Admin from "@/pages/Admin";

const TABS = [["users", "Usuários", Users], ["sponsored", "Patrocinados", Megaphone], ["seals", "Selos", BadgeCheck]];

export default function SuperAdmin() {
  const { user } = useAuth();
  const [tab, setTab] = useState("users");
  if (!user.is_super_admin) return <p className="py-24 text-center text-muted-foreground" data-testid="super-admin-denied">Área restrita ao Super-Administrador.</p>;

  return (
    <div className="mx-auto max-w-5xl space-y-6 py-6 pb-24 md:pb-10" data-testid="super-admin-page">
      <div className="flex items-center gap-3">
        <span className="grid h-11 w-11 place-items-center rounded-2xl bg-[hsl(var(--gold))] text-[#0B0F17]"><Crown size={20} /></span>
        <div><h1 className="text-2xl font-extrabold tracking-tight sm:text-3xl">Super-Admin</h1><p className="text-xs text-muted-foreground">Área isolada · {user.email}</p></div>
      </div>
      <div className="no-scrollbar flex gap-2 overflow-x-auto" data-testid="super-admin-tabs">
        {TABS.map(([k, label, Icon]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`super-tab-${k}`}
            className={`flex shrink-0 items-center gap-2 rounded-full px-4 py-2 text-sm font-bold transition-colors ${tab === k ? "bg-white text-[#0B0F17]" : "bg-white/5 text-muted-foreground hover:text-white"}`}>
            <Icon size={15} />{label}
          </button>
        ))}
      </div>
      {tab === "users" && <UsersPanel />}
      {tab === "sponsored" && <SponsoredPanel />}
      {tab === "seals" && <Admin />}
    </div>
  );
}
